import { Button } from "@nextui-org/react";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router";
import FeedbackButton from "../../components/common/FeedbackButton";
import FeedbackModal from "../../components/common/FeedbackModal";
import LoadingPage from "../../components/common/LoadingPage";
import { useFetchFeatureFlags } from "../../hooks/fetch-data/useFetchFeatureFlags";
import { useFetchPresetTrip } from "../../hooks/fetch-data/useFetchPresetTrip";
import { useModal } from "../../hooks/useModal";
import { useStripeCustomerInfo } from "../../hooks/useStripeCustomerInfo";
import BackButton from "../itinerary/_components/BackButton";
import Cover from "../itinerary/_components/Cover";
import DateFormModal from "./_components/DateFormModal";

const PresetItineraryPage = () => {
  const { presetId } = useParams();

  const { data: featureFlags } = useFetchFeatureFlags();

  const navigate = useNavigate();

  const { user, loadingStripeInfo, loadingUserInfo } = useStripeCustomerInfo();

  const {
    isOpen: isShowFeedback,
    handleClose: onCloseFeedbackModal,
    handleOpen: onOpenFeedbackModal,
  } = useModal();

  const {
    isOpen: isShowForm,
    handleClose: onCloseFormModal,
    handleOpen: onOpenFormModal,
  } = useModal();

  const { data: presetTrip, isFetching: isFetchingPresetTrip } =
    useFetchPresetTrip(presetId);

  const [currentSelectedDay, setCurrentSelectedDay] = useState<string>("");

  const isLoading =
    loadingStripeInfo || loadingUserInfo || isFetchingPresetTrip;

  if (isLoading)
    return (
      <LoadingPage
        message={isFetchingPresetTrip ? "Loading preset trip..." : "Loading..."}
      />
    );

  if (!user) {
    navigate("/sign-in");
    return null;
  }

  if (!presetTrip) {
    return <div>Not found</div>;
  }

  const isPresetItineraryEnabled = featureFlags?.["preset_itinerary"] ?? false;

  if (!isPresetItineraryEnabled) {
    navigate("/");
    return null;
  }

  return (
    <div className="relative flex flex-col w-full h-screen lg:h-screen overflow-hidden lg:p-5 bg-[#FCFCFC]">
      <BackButton onBackHome={() => navigate("/")} currentSelectedDay={""} />
      <div className="w-full lg:hidden h-full gap-y-5 flex flex-col overflow-hidden">
        <DateFormModal
          isOpen={isShowForm}
          onClose={onCloseFormModal}
          user={user}
          presetId={presetId}
        />
        {user ? (
          <FeedbackModal
            isOpen={isShowFeedback}
            onClose={onCloseFeedbackModal}
            userId={user.id}
          />
        ) : null}
        <FeedbackButton onClick={onOpenFeedbackModal} />
        {presetId ? (
          <Cover
            itinerary={presetTrip.itinerary}
            tripId={presetId}
            isPreset={true}
          />
        ) : null}
        {/* {presetId ? (
          <DayList
            tripId={presetId}
            tripDetail={presetTrip.itinerary}
            isTripInThePast={tripDetail.hasEnded()}
            handleUpdateItinerary={() => {}}
            onSetCurrentSelectedDay={setCurrentSelectedDay}
            currentSelectedDay={currentSelectedDay}
            isPremiumUser={false}
            isPreset={true}
            city={formatCity(presetTrip.itinerary.city)}
          />
        ) : null} */}
      </div>
      <Button
        onClick={onOpenFormModal}
        className="m-3 bg-black text-white h-[50px]"
      >
        Make it yours
      </Button>
    </div>
  );
};

export default PresetItineraryPage;
